import styled from "@emotion/styled";
import { getFullName, getPhoneNumber } from "../../utils/shared";
import Avatar from "../generic/Avatar";
import { useMemo } from "react";

const StyledUserItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 8px;
  transition: background 0.2s ease;
  border-bottom: 2px solid #f5f5f5;

  .user-details {
    flex: 1;
    min-width: 0;
  }

  .user-name {
    font-size: 15px;
    font-weight: 500;
    color: #262626;
    margin-bottom: 4px;
  }

  .user-email {
    font-size: 12px;
    color: #8c8c8c;
  }
`;

const UserItem = ({ user, children = null }) => {
  const phone = useMemo(() => {
    return getPhoneNumber(user);
  }, [user]);

  return (
    <StyledUserItem key={user.id} className="user-item ">
      <Avatar user={user} size={38} />

      <div className="user-details">
        <div className="user-name ellipsis-text">{getFullName(user)}</div>
        <div className="user-email ellipsis-text">
          {phone && `${phone} | `}
          {user.email || "Email not Found"}
        </div>
      </div>
      <div>{children}</div>
    </StyledUserItem>
  );
};

export default UserItem;
